import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { ActionIcon } from '@mummssoftware/common-ui';
import EditIcon from '@material-ui/icons/Edit';
import StopIcon from '@material-ui/icons/Stop';

import { AppContext } from '../../App/AppContext';
import { MedContext } from '../../App/MedContext';
import { SET_MOBILE_EDITABLE } from '../../App/constants';

const TopBarContent = ({ messages, smallWidget }) => {
  const { isMobile } = useContext(AppContext);

  const { isMobileEditable, dispatch } = useContext(MedContext);

  const handleMobileEdit = () => {
    dispatch({
      type: SET_MOBILE_EDITABLE,
      payload: !isMobileEditable,
    });
  };

  const editButtonMsg = isMobileEditable ? (
    <FormattedMessage {...messages.stopEditBTN} />
  ) : (
    <FormattedMessage {...messages.editBTN} />
  );

  // eslint-disable-next-line consistent-return
  const getTopBarContent = () => (
    <div>
      {isMobile && !smallWidget && (
        <ActionIcon
          title={editButtonMsg}
          style={{
            marginBottom: '10px',
            float: 'right',
          }}
          Icon={isMobileEditable ? StopIcon : EditIcon}
          onClick={handleMobileEdit}
        />
      )}
    </div>
  );
  return getTopBarContent();
};

export default React.memo(TopBarContent);
